import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import LeadsProfileTable from "../LeadsProfileTable/Index";
import ProspectProfileTable from "../ProspectProfileTable/Index";
import LeadsSharedProfileTable from "../LeadsProfileTable/LeadsSharedProfileTable";
import ProspectSharedProfileTable from "../ProspectProfileTable/ProspectSharedProfileTable";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import NewAiProfileMobile from "./NewAiProfileMobile";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { createTheme, Stack } from "@mui/material";
import { AI_PROSPECT_PROFILE } from "../../../Utils/Constants";
import { AI_PROFILE_FORM_TABLE } from "../../../Utils/Constants";
import { ThemeProvider } from "@emotion/react";
/* ------------------ TAB PANEL ------------------ */
function CustomTabPanel({ children, value, index }) {
  if (value !== index) return null;

  return (
    <Box>
      <Typography component="div">{children}</Typography>
    </Box>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
const theme = createTheme({
  components: {
    MuiTabs: {
      styleOverrides: {
        indicator: {
          background: "transparent",
          borderBottom: "2px solid #e32726 ",
        },
      },
    },
  },
});
/* ------------------ MAIN COMPONENT ------------------ */
export default function TabsAiProfileMobile({
  setRefState,
  setRefStatenew,
  setRefStateShared,
  setRefStateSharednew,
  isDecisionMakerExcel,
  setIsDecisionMakerExcel,
  shareRecord,
  setShareRecord,
  isMobile,
  isTabletPortrait,
}) {
  const location = useLocation();
  const { tab } = useParams();
  const [value, setValue] = React.useState(Number(tab) || 0);
  const [hoverIndex, setHoverIndex] = React.useState(null);
  const [isExpanded, setIsExpanded] = React.useState(true);
  const [openTableDrawer, setOpenTableDrawer] = useState(false);

  React.useEffect(() => {
    if (location.state !== undefined) {
      setValue(location.state);
    }
  }, [location.state]);

  const menuItems = [
    "My Lead Profiles",
    "My Prospect Profiles",
    "Shared Lead Profiles",
    "Shared Prospect Profiles",
  ];

  const handleMenuClick = (index) => {
    if (index === 0) {
      setIsExpanded(!isExpanded);
    }
    setValue(index);
  };
  React.useEffect(() => {
    setValue(0);
    setIsExpanded(true);
  }, []);
  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ py: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  const theme = createTheme({
    components: {
      MuiTabs: {
        styleOverrides: {
          indicator: {
            background: "transparent",
            borderBottom: "2px solid #e32726 ",
          },
        },
      },
    },
  });
  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const navigate = useNavigate();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {isTabletPortrait ? (
        <Box sx={{ width: "100%" }} className="main-box-tabs">
          <Box
            sx={{ borderBottom: 1, borderColor: "divider" }}
            className="inner-box-tabs"
          >
            <ThemeProvider theme={theme}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                className="main-tabs-decision-makers"
              >
                <Tab label="My Lead Profiles" {...a11yProps(0)} />
                <Tab label="My Prospect Profiles" {...a11yProps(1)} />
                <Tab label="Shared Lead Profiles" {...a11yProps(2)} />
                <Tab label="Shared Prospect Profiles" {...a11yProps(3)} />
              </Tabs>
            </ThemeProvider>
            <Stack className="section-new-ai-lead">
              <Button
                variant="text"
                onClick={() => {
                  if (value === 0 || value === 2) {
                    navigate(AI_PROFILE_FORM_TABLE);
                  } else {
                    navigate(AI_PROSPECT_PROFILE);
                  }
                }}
                className="new-ai-lead-button-section-button"
              >
                <div className="new-ai-lead-button-section">
                  <AddIcon />
                  <p
                    className="text-ai-lead-button-section"
                    style={{ textTransform: "none" }}
                  >
                    {value === 0 || value === 2
                      ? "New AI lead profile"
                      : "New Prospect profile"}
                  </p>
                </div>
              </Button>
            </Stack>
          </Box>
          <Box
            style={{
              flex: 1,
              overflow: "auto",
            }}
          >
            <CustomTabPanel value={value} index={0}>
              <LeadsProfileTable
                setRefState={setRefState}
                isDecisionMakerExcel={isDecisionMakerExcel}
                setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                shareRecord={shareRecord}
                setShareRecord={setShareRecord}
                isMobile={isMobile}
                isTabletPortrait={isTabletPortrait}
              />
            </CustomTabPanel>

            <CustomTabPanel value={value} index={1}>
              <ProspectProfileTable
                setRefStatenew={setRefStatenew}
                isDecisionMakerExcel={isDecisionMakerExcel}
                setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                shareRecord={shareRecord}
                setShareRecord={setShareRecord}
                isMobile={isMobile}
                isTabletPortrait={isTabletPortrait}
              />
            </CustomTabPanel>

            <CustomTabPanel value={value} index={2}>
              <LeadsSharedProfileTable
                setRefState={setRefStateShared}
                isDecisionMakerExcel={isDecisionMakerExcel}
                setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                shareRecord={shareRecord}
                setShareRecord={setShareRecord}
                isMobile={isMobile}
                isTabletPortrait={isTabletPortrait}
              />
            </CustomTabPanel>

            <CustomTabPanel value={value} index={3}>
              <ProspectSharedProfileTable
                setRefStatenew={setRefStateSharednew}
                isDecisionMakerExcel={isDecisionMakerExcel}
                setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                shareRecord={shareRecord}
                setShareRecord={setShareRecord}
                isMobile={isMobile}
                isTabletPortrait={isTabletPortrait}
              />
            </CustomTabPanel>
          </Box>
        </Box>
      ) : (
        // mobile screen
        <Box
          style={{
            display: "grid",
            width: "100%",
            height: "100%",
            backgroundColor: "#fff",
          }}
        >
          <div
            style={{
              width: "100%",
              padding: "60px 10px 10px 10px",
              backgroundColor: "#F3F4F9",
            }}
          >
            <Typography
              style={{
                fontSize: 16,
                fontWeight: 700,
                marginBottom: 16,
                color: "#000",
              }}
            >
              AI Profile
            </Typography>

            {menuItems.map((label, index) => {
              const isActive = value === index;
              const isVisible = index === 0 || isExpanded;

              if (!isVisible) return null;

              return (
                <div
                  key={index}
                  onClick={() => handleMenuClick(index)}
                  onMouseEnter={() => setHoverIndex(index)}
                  onMouseLeave={() => setHoverIndex(null)}
                  style={{
                    cursor: "pointer",
                    fontSize: 14,
                    marginBottom: 4,
                    alignItems: "center",
                    justifyContent: "space-between",
                    color: "#e32726",
                    fontWeight: isActive ? 600 : 400,
                  }}
                >
                  <span>{label}</span>
                  {index === 0 ? (
                    isActive ? (
                      isExpanded ? (
                        <KeyboardArrowDownIcon style={{ fontSize: 20 }} />
                      ) : (
                        <KeyboardArrowRightIcon style={{ fontSize: 20 }} />
                      )
                    ) : null
                  ) : isActive ? (
                    <KeyboardArrowDownIcon style={{ fontSize: 20 }} />
                  ) : (
                    <KeyboardArrowRightIcon
                      style={{ fontSize: 20, opacity: 0 }}
                    />
                  )}
                </div>
              );
            })}

            <Button
              startIcon={<AddIcon />}
              style={{
                width: "70%",
                backgroundColor: "#e32726",
                color: "#fff",
                fontSize: 14,
                textTransform: "none",
                fontWeight: 500,
                padding: "8px 0",
                marginTop: "12px",
              }}
              onClick={() => setOpenTableDrawer(true)}
            >
              Create New AI Profile
            </Button>
          </div>

          {/* ---------------- RIGHT CONTENT ---------------- */}
          <Box
            style={{
              flex: 1,
              overflow: "auto",
            }}
          >
            <CustomTabPanel
              value={value}
              index={0}
              className="mobile-profilepage-boxs"
            >
              <LeadsProfileTable
                setRefState={setRefState}
                isDecisionMakerExcel={isDecisionMakerExcel}
                setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                shareRecord={shareRecord}
                setShareRecord={setShareRecord}
                isMobile={isMobile}
              />
            </CustomTabPanel>

            <CustomTabPanel
              value={value}
              index={1}
              className="mobile-profilepage-boxs"
            >
              <ProspectProfileTable
                setRefStatenew={setRefStatenew}
                isDecisionMakerExcel={isDecisionMakerExcel}
                setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                shareRecord={shareRecord}
                setShareRecord={setShareRecord}
                isMobile={isMobile}
              />
            </CustomTabPanel>

            <CustomTabPanel
              value={value}
              index={2}
              className="mobile-profilepage-boxs"
            >
              <LeadsSharedProfileTable
                setRefState={setRefStateShared}
                isDecisionMakerExcel={isDecisionMakerExcel}
                setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                shareRecord={shareRecord}
                setShareRecord={setShareRecord}
                isMobile={isMobile}
              />
            </CustomTabPanel>

            <CustomTabPanel
              value={value}
              index={3}
              className="mobile-profilepage-boxs"
            >
              <ProspectSharedProfileTable
                setRefStatenew={setRefStateSharednew}
                isDecisionMakerExcel={isDecisionMakerExcel}
                setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                shareRecord={shareRecord}
                setShareRecord={setShareRecord}
                isMobile={isMobile}
              />
            </CustomTabPanel>
            <NewAiProfileMobile
              openTableDrawer={openTableDrawer}
              setOpenTableDrawer={setOpenTableDrawer}
              value={value}
            />
          </Box>
        </Box>
      )}
    </>
  );
}
